const getSort = (query) => {
  return query?.sort || 'all'
}

export { getSort }
